module.exports = __webpack_public_path__ + "img/right_icon_2.2a080b7.png";